import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";
import { DataMainTemplate } from "@nocios/presentation-kit";

const PageId = 2;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = (): DataMainTemplate => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_1.png`;
  const rightSideImage_2 = `${baseImageUrl}animation_2.png`;
  const rightSideImage_3 = `${baseImageUrl}animation_3.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    top: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
    width: "var(--width-1920)",
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [400, 600, 600];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const backButtonConfig = {
    label: "Back",
    type: "back" as const,
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: `linear-gradient(268deg, rgba(10, 45, 101, 0.00) 28.65%, #000000 97.16%), linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%)`,
    title: "Effortless Control,\nSeamless Connectivity",
    description: `Manage all your connected devices from a\nsingle, intuitive dashboard. Whether it’s smart\nTVs, routers, or security cameras, stay in control\nwith real-time status updates and performance\ninsights.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Live Device Dashboard: View and manage all\nconnected devices at a glance.</li>\n<li>Health Indicators: Get real-time insights on\ndevice status and network health.</li>\n<li>Smart Alerts: Receive notifications for\npotential issues and quick fixes</li></ul>`}
      />
    ),
    rightSideComponent: (
      <>
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 1 ? 1 : 0 }} />
        <img src={rightSideImage_2} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 2 ? 1 : 0 }} />
        <img src={rightSideImage_3} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 3 ? 1 : 0 }} />
      </>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
